import { ImageName } from "@mcleod/images";
import { Label, TableRow, TableRowDisplayEvent } from "@mcleod/components";
import { HorizontalAlignment } from "@mcleod/core";
import { AutogenLayoutGooglePlacesSearch } from "./autogen/AutogenLayoutGooglePlacesSearch";

export class GooglePlacesSearch extends AutogenLayoutGooglePlacesSearch {

    tableGooglePlacesOnDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const row = (event.target as TableRow).data;
        const isDuplicate = row.get("duplicate_location");
        const labelLocationId = tableRow.findComponentById("celllocation_id") as Label;
        if (isDuplicate) {
            labelLocationId.imageName = ImageName.circlePlusFilled;
            labelLocationId.imageProps = { stroke: "primary-reverse", fill: "primary" };
            labelLocationId.tooltip = "Duplicate Google Place";
            labelLocationId.align = HorizontalAlignment.LEFT;
        }
    }
}
